import { Input, Modal } from 'antd';
import React from 'react';

/** 授权管理操作在发请求前收集原因，取消时不会提交任何变更。 */
export function requestAdminReason(): Promise<Record<string, string>> {
  return new Promise((resolve, reject) => {
    let reason = '';
    Modal.confirm({
      title: '填写操作原因',
      content: <Input.TextArea rows={3} maxLength={200} placeholder="请输入工单号或修改原因" onChange={(event) => { reason = event.target.value; }} />,
      onOk: () => {
        if (!reason.trim()) return Promise.reject(new Error('请填写操作原因'));
        return resolve({ 'X-Operation-Reason': encodeURIComponent(reason.trim()) });
      },
      onCancel: () => reject(new Error('已取消操作')),
    });
  });
}
